import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPoliteScoreActionTypes {
  SetRating = 'NEW_REVIEW/Polite/SET',
}

type TSetPoliteScore = ITypedReduxAction<EPoliteScoreActionTypes.SetRating, number>;

export const setPoliteScore: (rating: number) => TSetPoliteScore = actionGenerator<
  EPoliteScoreActionTypes.SetRating,
  number
>(EPoliteScoreActionTypes.SetRating);

export type TPoliteScore = TSetPoliteScore;
